import { gql, TypedDocumentNode } from "@apollo/client";

import { FlowsProject, Role } from "types/generated";

import { FlowsProjectRoleBindingView } from "./types";

export type FlowsProjectRoleBindingsData = {
  flowsProjects: Array<
    Pick<FlowsProject, "id" | "name"> & {
      roleBindings: FlowsProjectRoleBindingView[];
    }
  >;
  roles: Pick<Role, "id" | "name">[];
};

export const FLOWS_PROJECT_ROLE_BINDINGS_WITH_ROLES: TypedDocumentNode<FlowsProjectRoleBindingsData> = gql`
  query FlowsProjectRoleBindingsWithRoles {
    flowsProjects {
      id
      name
      roleBindings {
        id
        flowsProjectID
        space {
          id
          name
          accessLevel
        }
        role {
          id
          name
          actions
          description
          isSystem
        }
      }
    }
    roles {
      id
      name
    }
  }
`;
